import { api } from "@api/api";
import { TiledeskDashboardAccess } from "@modules/tiledesk/types";

export interface OpenTiledeskDashboardInput {
  agreementId: string;
  role?: "agent" | "admin";
}

export async function openTiledeskDashboardService({
  agreementId,
  role = "admin",
}: OpenTiledeskDashboardInput): Promise<TiledeskDashboardAccess> {
  const { data } = await api.post<TiledeskDashboardAccess>(
    `v1/tiledesk/agreements/${agreementId}/dashboard/`,
    { role }
  );
  return data;
}
